<template>
 <div :class="windowClass">
        <v-row no-gutters class="pa-2">
          <span class="subtitle-1 mt-5">FISHCAR: {{fishcar.name}}</span>
          <v-spacer/>
            <span style="width: 250px;">
              <v-autocomplete
                :items="Fishcars"
                v-model="fishcar"
                item-text="name"
                label="Select Fishcar"
                return-object
                @change="GET_INCOME_SOURCE_SUMMARY(fishcar.id),GET_SALES_SUMMARY(fishcar.id)"
              ></v-autocomplete>
            </span>
        </v-row>
        <reports-income/>
        <reports-monthly-sales/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
      Fishcars:[],
      fishcar: {}
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
            this.SET_MENUS()
          this.GET_INCOME_SOURCE_SUMMARY(0)
          this.GET_SALES_SUMMARY(0)
          this.getFishcars()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      getFishcars: function() {
        this.$http.post("supplier/list", {}).then(response => {
              response.data.data != null?this.Fishcars = response.data.data:this.Fishcars=[]
              this.Fishcars.unshift({id: 0, name: 'ALL FISHCARS'})
          }).catch(e => {
           console.log(e.data)
         })
     },
    },
  }
</script>